<template>
    <div>
        <div>
            <div class="page-wrapper">
                <div class="page-body">
                    <div class="row g-2">
                        <div class="col">
                            <div class="card">
                                <div class="card-header">
                                    <div class="col">
                                        <h3 class="card-title">
                                            <i class="ti ti-alert-triangle"></i>
                                            Regras de alerta
                                        </h3>
                                    </div>
                                    <div class="col-auto">
                                        <a
                                            href="/alert-rules/new"
                                            class="btn btn-primary"
                                        >
                                            <i class="ti ti-plus"></i>
                                            Criar regra de alerta
                                        </a>
                                    </div>
                                </div>

                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-3 mb-2">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="filter.query"
                                                @change="updateFilter"
                                                placeholder="Buscar regras de alerta"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="table" v-if="alertRulesList.length">
                                    <table
                                        class="table table-vcenter card-table"
                                    >
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Tipo</th>
                                                <th>Janela de captura</th>
                                                <th>Ação</th>
                                                <th>Status</th>
                                                <th>Atualização</th>
                                                <th>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="alertRule in alertRulesList"
                                                v-bind:key="alertRule._id"
                                            >
                                                <td>
                                                    {{ alertRule.name }}
                                                </td>
                                                <td>
                                                    {{
                                                        getTypeLabel(
                                                            alertRule.type
                                                        )
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        getTimeWindowLabel(
                                                            alertRule.timewindow_seconds
                                                        )
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        getActionLabel(
                                                            alertRule.action
                                                        )
                                                    }}
                                                </td>
                                                <td>
                                                    <span
                                                        v-if="alertRule.enabled"
                                                        class="badge bg-green text-green-fg"
                                                        >Ativo</span
                                                    >
                                                    <span
                                                        v-else
                                                        class="badge bg-red text-red-fg"
                                                        >Inativo</span
                                                    >
                                                </td>
                                                <td>
                                                    {{
                                                        formatDate(
                                                            alertRule.updated_at
                                                        )
                                                    }}
                                                </td>
                                                <td>
                                                    <span class="dropdown">
                                                        <button
                                                            class="btn btn-sm dropdown-toggle"
                                                            data-bs-toggle="dropdown"
                                                        >
                                                            Opções
                                                        </button>
                                                        <div
                                                            class="dropdown-menu"
                                                        >
                                                            <a
                                                                v-bind:href="
                                                                    '/alert-rules/edit/' +
                                                                    alertRule._id
                                                                "
                                                                class="dropdown-item"
                                                            >
                                                                <i
                                                                    class="ti ti-pencil"
                                                                ></i>
                                                                Editar
                                                            </a>
                                                            <a
                                                                href="#"
                                                                @click="
                                                                    (e) => {
                                                                        duplicateAlertRule(
                                                                            e,
                                                                            alertRule
                                                                        )
                                                                    }
                                                                "
                                                                class="dropdown-item"
                                                            >
                                                                <i
                                                                    class="ti ti-copy"
                                                                ></i>
                                                                Duplicar regra
                                                            </a>
                                                            <a
                                                                v-bind:href="
                                                                    '/alert-rules/delete/' +
                                                                    alertRule._id
                                                                "
                                                                class="dropdown-item bg-danger-lt"
                                                            >
                                                                <i
                                                                    class="ti ti-trash"
                                                                ></i>
                                                                Remover
                                                            </a>
                                                        </div>
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div
                                    class="card-body"
                                    v-if="
                                        !alertRulesList.length && !filter.query
                                    "
                                >
                                    <div class="empty">
                                        <p class="empty-title">
                                            Nenhuma regra de alerta criado
                                            ainda.
                                        </p>
                                        <p class="empty-subtitle text-muted">
                                            Clique no botão abaixo para criar
                                            sua primeira regra de alerta
                                            personalizada!
                                        </p>
                                        <div class="empty-action">
                                            <a
                                                href="/alert-rules/new"
                                                class="btn btn-primary"
                                            >
                                                <i class="ti ti-plus"></i>
                                                Criar regra de alerta
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="card-body"
                                    v-if="
                                        !alertRulesList.length && filter.query
                                    "
                                >
                                    <div class="empty bg-muted-lt">
                                        <p class="empty-title">
                                            Nenhuma regra de alerta encontrado
                                            para esta busca.
                                        </p>
                                    </div>
                                </div>

                                <div class="card-footer">
                                    <Pagination
                                        :key="paginationKey"
                                        :showPerPage="showPerPage"
                                        :currentPage="currentPage"
                                        :total="total"
                                        v-if="total"
                                        @pageChange="updatePage"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from "../services/event-bus"
import Api from "../services/api"
import { store } from "../store"
import Pagination from "../components/Pagination"
import moment from "moment"

export default {
    name: "AlertRulesPage",
    components: {
        Pagination
    },
    data() {
        return {
            paginationKey: null,
            showPerPage: 10,
            currentPage: 1,
            total: 0,
            alertRulesList: [],
            filter: {
                query: ""
            }
        }
    },
    async mounted() {
        store.showSidebar = true
        store.showHeader = true
    },
    async mounted() {
        this.currentPage = parseInt(this.$route.query.page) || 1
        this.filter.query = this.$route.query.query || ""
        this.loadAlertRules()
    },
    methods: {
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY HH:mm:ss")
        },
        async loadAlertRules() {
            this.paginationKey = Math.random()

            var response = await Api.alertRules.list(
                this.currentPage,
                this.showPerPage,
                this.filter
            )

            this.alertRulesList = response.data.items
            this.total = response.data.total
        },
        updateFilter() {
            this.$router.replace({
                query: {
                    page: 1,
                    query: this.filter.query
                }
            })

            this.loadAlertRules()
        },

        async duplicateAlertRule(e, alertRule) {
            e.preventDefault()

            if (
                confirm(
                    "Deseja realmente duplicar esta regra de alerta? A cópia será criada desabilitada."
                )
            ) {
                await Api.alertRules.duplicate(alertRule._id)

                EventBus.emit("message", {
                    type: "success",
                    message: "Regra de alerta duplicado com sucesso!"
                })

                this.$router.go()
            }
        },

        updatePage(page) {
            this.currentPage = page
            this.paginationKey = Math.random()

            var queryParams = {
                page: page
            }

            if (this.filter.query) queryParams.query = this.filter.query

            this.$router.replace({
                query: queryParams
            })

            this.loadAlertRules()
        },

        getActionLabel(value) {
            switch (value) {
                case "email":
                    return "E-mail"
                case "webhook":
                    return "Webhook"
                default:
                    return "Desconhecido"
            }
        },

        getTypeLabel(value) {
            switch (value) {
                case "match_log":
                    return "Match de logs"
                default:
                    return "Desconhecido"
            }
        },

        getTimeWindowLabel(seconds) {
            switch (seconds) {
                case 60:
                    return "1 minuto"
                case 300:
                    return "5 minutos"
                case 600:
                    return "10 minutos"
                case 1800:
                    return "30 minutos"
                case 3600:
                    return "1 hora"
            }

            return ""
        }
    }
}
</script>
